import styled from 'styled-components';

const LandingPageContainer = styled.div`
    min-height: 100vh;
    background-color: #1f2021;
    background-size: cover;
    position: relative;
    .overlay {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgb(0 0 0 / 60%);
    }
    .text {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 50%;
        padding: 50px;
        background-color: var(--transparent-color);
        color: white;
        display: flex;
        justify-content: flex-end;
        @media (max-width: 767px) {
            width: 100%;
        }
        .content {
            max-width: 500px;
            @media (max-width: 767px) {
                max-width: 100%;
            }
            h2 {
                font-size: 32px;
                font-weight: normal;
                line-height: 1.5;
                margin-bottom: 20px;
            }
            p {
                font-size: 14px;
                line-height: 2;
            }
        }
    }
    .change-background {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        color: #ddd;
        @media (max-width: 767px) {
            display: none;
        }
    }
    .fa-angle-left {
        left: 30px;
        cursor: pointer;
    }
    .fa-angle-right {
        right: 30px;
        cursor: pointer;
    }
    .bullets {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 30px;
        display: flex;
        cursor: pointer;
        li {
            width: 20px;
            height: 20px;
            border: 1px solid white;
            border-radius: 50%;
            margin-right: 10px;
            &.active {
                background-color: var(--main-color);
                border-color: var(--main-color);
            }
        }
    }
`;

export default LandingPageContainer;
